<i18n>
{
  "en": {
    "latest_movies": "Latest Movies",
    "vip_badge": "VIP",
    "svip_badge": "SVIP",
    "annual_badge": "Annual",
    "limited_tag": "Limited Availability",
    "expired_tag": "Availability Ended",
    "future_tag": "Upcoming",
    "vr_tag": "VR",
    "view_more": "View More"
  },
  "ja": {
    "latest_movies": "新着動画",
    "vip_badge": "VIP",
    "svip_badge": "超VIP",
    "annual_badge": "年間",
    "limited_tag": "期間限定",
    "expired_tag": "配信期間終了",
    "future_tag": "近日配信",
    "vr_tag": "VR",
    "view_more": "もっと見る"
  }
}
</i18n>

<template>
<div class="container">
  <div class="section">
    <h2>{{ $t('latest_movies') }}</h2>
    <div class="grid is-movie is-primary">

      <div v-for="(movie, index) in movieList" :key="movie.MovieID" class="grid-item">
        <router-link
          :to="`/movies/${movie.MovieID}/`"
          :data-movie-id="movie.MovieID"
          :data-movie-title="movie.Title"
          :data-actress-name="movie.Actor"
          class="entry">
          <div class="entry-media">
            <img class="media-image"
              :src="movie.thumbnailSrc"
              @error="useFallbackImage(index)"
              loading="lazy"
              alt=""
              v-sfw>
          </div>
          <div class="entry-meta" >
            <div class="meta-date">{{ movie.ReleaseDate }}<span v-if="movie.ExpireDate"> &ndash; {{ movie.ExpireDate }}</span></div>
            <div class="meta-title">
              <span v-if="!newXPEligible && movie.isVIP" class="tag-member is-vip">{{ $t('vip_badge') }}</span>
              <span v-if="!newXPEligible && movie.isSVIP" class="tag-member is-svip">{{ $t('svip_badge') }}</span>
              <span v-if="!newXPEligible && movie.isAnnual" class="tag-member is-annual">{{ $t('annual_badge') }}</span>
              <span v-if="locale === 'ja'">{{ movie.Title }}</span>
              <span v-if="locale === 'en'">{{ movie.TitleEn || movie.ActressesEn.join(', ') }}</span>
            </div>
            <div class="meta-description" v-if="locale == 'ja'">
              {{ truncateString(movie.Desc, 80) }}<span class="meta-link">{{ $t('view_more') }}</span>
            </div>
            <div class="meta-status">
            <div v-if="movie.IsLimited" class="tag-status is-limited">{{ $t('limited_tag') }}</div>
            <div v-if="movie.IsExpired" class="tag-status is-expired">{{ $t('expired_tag') }}</div>
            <div v-if="movie.IsComingSoon" class="tag-status is-future">{{ $t('future_tag') }}</div>
            <div v-if="movie.isVR" class="tag-status is-vr">{{ $t('vr_tag') }}</div>
          </div>
          </div>
        </router-link>
      </div>

    </div>
    <div class="section">
      <div class="button-box is-centered">
        <router-link class="button is-outlined is-large is-rounded" to="/list/?o=newest">{{ $t('view_more') }}<i class="iconf-keyboard-arrow-right is-right"></i></router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint max-len: 0 */

import { prefetch } from 'quicklink';
import MovieHelper from '@/assets/js/utils/movie';
import BifrostAPI from '@/assets/js/services/Bifrost/API';

export default {
  props: {
    numMovies: Number,
  },
  data() {
    return {
      movieList: [],
    };
  },
  created() {
    this.getMovies(this.userTypeID);
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    userTypeID() {
      return this.$store.getters['user/typeID'];
    },
  },
  methods: {
    async getMovies(userTypeID) {
      // fetch newest movies
      const bfAPI = new BifrostAPI();
      const result = await bfAPI.getMovieListNewest(0, parseInt(this.numMovies, 10));
      const movieList = MovieHelper.expandDetailsList(result.Rows, this.locale, userTypeID);
      this.movieList = MovieHelper.filterExcludedMovieList(movieList, userTypeID);

      // prefetch movie detail jsons and posters
      this.prefetchMovies();
    },
    prefetchMovies() {
      // using vue-mobile-detection lib, this.$isMobile() returns a Boolean value whether or not the user is using a mobile
      const prefetchedMovieList = (this.$isMobile()) ? this.movieList.slice(0, 1) : this.movieList;
      for (let i = 0; i < prefetchedMovieList.length; i += 1) {
        // movie detail jsons
        prefetch(`/dyn/phpauto/movie_details/movie_id/${prefetchedMovieList[i].MovieID}.json`);
        // movie posters
        prefetch(`/assets/sample/${prefetchedMovieList[i].MovieID}/str.jpg`);
      }
    },
    useFallbackImage(index) {
      // missing movie poster thumbnail, fallback to "no image" image. since this is a "newest
      // movies" list, we can guarantee that if the thumbnail poster is missing, then this movie
      // isn't quite ready yet
      this.$set(this.movieList[index], 'thumbnailSrc', '/img/common/now_printing.png');
    },
    truncateString(str, maxChars) {
      return (str.length > maxChars) ? `${str.substring(0, maxChars)}…` : str;
    },
  },
  watch: {
    userTypeID(newVal) {
      this.getMovies(newVal);
    },
    numMovies(newVal, oldVal) {
      if (newVal !== oldVal) this.getMovies(this.userTypeID);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
